module.exports = __webpack_public_path__ + "static/media/home.e1ecfbd4.svg";